import { WebPageJsonLd } from "next-seo";
import { Network } from "~/modules/networks/types";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { getNetworkURL } from "~/routes";

// // // //

export function getNetworkPageDescription(props: { network: Network }): string {
    const { network } = props;

    return `Explore comprehensive insights on ${network.name}, from issuer and platform details to market cap, supply metrics, and transfer volumes. Analyze quantitative trends and asset-specific breakdowns for deeper insights.`;
}

// // // //

/**
 * Renders WebPage SEO metadata for the Network Individual page using the `ArticleJsonLd` component from `next-seo`.
 *
 * @param {Object} props - The component props.
 * @param {Article} props.network - The Network data used to generate SEO metadata.
 */
export function NetworkIndividualWebpageSEO(props: { network: Network }) {
    const { network } = props;

    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(getNetworkURL({ networkSlug: network.slug }))}
            description={getNetworkPageDescription({ network })}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
